import type { QueryClient } from "@tanstack/react-query";
import { invalidateReportsCache } from "@/lib/react-query/invalidateReportsCache";

export function invalidateAppointmentUiCache(
  queryClient: QueryClient,
  options?: { appointmentId?: string | null; clearLists?: boolean },
): void {
  if (options?.clearLists) {
    queryClient.removeQueries({ queryKey: ["appointments"] });
    queryClient.removeQueries({ queryKey: ["grooming-appointments"] });
  }

  queryClient.invalidateQueries({ queryKey: ["appointments"], exact: false });
  queryClient.invalidateQueries({ queryKey: ["grooming-appointments"], exact: false });
  queryClient.invalidateQueries({ queryKey: ["finalized-appointments"], exact: false });
  queryClient.refetchQueries({ queryKey: ["appointments"], exact: false });
  queryClient.refetchQueries({ queryKey: ["grooming-appointments"], exact: false });
  queryClient.refetchQueries({ queryKey: ["finalized-appointments"], exact: false });

  if (options?.appointmentId) {
    queryClient.invalidateQueries({ queryKey: ["appointment", options.appointmentId], exact: false });
    queryClient.invalidateQueries({ queryKey: ["appointment-financial", options.appointmentId], exact: false });
    queryClient.invalidateQueries({ queryKey: ["sale-by-appointment", options.appointmentId], exact: false });
    queryClient.invalidateQueries({ queryKey: ["appointment-patient-packages", options.appointmentId], exact: false });
    queryClient.invalidateQueries({ queryKey: ["appointment-items", options.appointmentId], exact: false });
    queryClient.refetchQueries({ queryKey: ["appointment", options.appointmentId], exact: false });
    queryClient.refetchQueries({ queryKey: ["appointment-financial", options.appointmentId], exact: false });
    queryClient.refetchQueries({ queryKey: ["sale-by-appointment", options.appointmentId], exact: false });
    queryClient.refetchQueries({ queryKey: ["appointment-patient-packages", options.appointmentId], exact: false });
    queryClient.refetchQueries({ queryKey: ["appointment-items", options.appointmentId], exact: false });
  }

  invalidateReportsCache(queryClient);
  queryClient.refetchQueries({
    predicate: (query) => {
      const key0 = query.queryKey?.[0];
      return typeof key0 === "string" && key0.startsWith("reports-");
    },
  });
}
